module.exports = __webpack_public_path__ + "static/img/14000116.af9edafd.png";